import axios from 'axios';
import { csrfToken } from '@/util/helpers/ajax-helpers';

export const trevorAxios = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: {
    'x-csrf-token': csrfToken(),
  },
});
